import React from "react";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import ThemeContextProvider from "./src/theme/Context";
import ResponsiveLayout from "./src/layouts/Responsive";

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return (
    <ThemeContextProvider>
      <ResponsiveLayout {...props}>{element}</ResponsiveLayout>
    </ThemeContextProvider>
  );
};
